<template>
  <div>
    <v-container class="mb-5">
      <slot name="before-basic-form"></slot>
      <v-row>
        <v-col cols="12">
          <v-text-field
              v-model="tradeContract.name"
              label="契約名"
              :rules="[v => !!v || '契約名が必要です']"
              hint="後から変更が可能です"
              autofocus>
          </v-text-field>
        </v-col>
        <v-col cols="12">
          <v-textarea
              v-model="tradeContract.description"
              label="説明"
              messages="複数行入力可"
              rows="1"
              auto-grow>
          </v-textarea>
        </v-col>
      </v-row>
      <slot name="after-basic-form"></slot>
    </v-container>
    <v-card elevation="0" tile v-if="!isOffer">
<!--      <v-card-subtitle class="py-0 my-4">-->
<!--        <el-radio v-model="contractType" label="recruitment">取引を募集する</el-radio>-->
<!--      </v-card-subtitle>-->
      <v-card-subtitle class="py-0 my-4">
        <el-radio v-model="contractType" label="draft">以下から取引先を選択する</el-radio>
        <span>取引先を選択するためには、予め<router-link to="/profileSearch/customers">取引先リスト</router-link>に該当する事業者を登録します</span>
      </v-card-subtitle>
      <v-divider></v-divider>
      <v-card-text class="px-0 pt-0">
        <el-table :data="customerTerminals" height="500" :style="{filter: isRecruitment ? 'brightness(0.9) opacity(0.5)' : 'none'}">
          <el-table-column
              label="選択"
              column-key="selected"
              width="70"
              align="center">
            <template #default="{row}">
              <table-inline>
                <el-radio
                    :value="row.selected"
                    @change="setSelected(row)"
                    :label="true"
                    :disabled="isRecruitment"
                    class="no-label">
                </el-radio>
              </table-inline>
            </template>
          </el-table-column>
          <el-table-column
              label="事業者名"
              prop="owner.name"
              width="200">
          </el-table-column>
          <el-table-column
              label="説明"
              prop="owner.description">
            <template #default="{row}">
              <table-inline>
                <text-field-like
                    :value="row.owner.description"
                    placeholder="未設定"
                    multi-line>
                </text-field-like>
              </table-inline>
            </template>
          </el-table-column>
          <el-table-column
              label="サイト名"
              prop="name"
              width="200">
          </el-table-column>
          <el-table-column
              label="説明"
              prop="description">
            <template #default="{row}">
              <table-inline>
                <text-field-like
                    :value="row.description"
                    placeholder="未設定"
                    multi-line>
                </text-field-like>
              </table-inline>
            </template>
          </el-table-column>
        </el-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import TableInline from "@/components/atoms/TableInline.vue";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import natsort from "natsort";

const sortFn = natsort();

const defaultTradeContract = {
  name: '',
  description: '',
  targetTerminalId: null, // 選択された terminal_id
};

export default {
  name: "CreateTradeContractForm",
  components: {TextFieldLike, TableInline},
  inject: {
    dialog: {default: null},
    form: {default: null}
  },
  props: {
    value: {
      required: false
    },
    group: {
      type: Object,
      required: true,
    },
    initialContractType: {
      type: String,
      default: 'draft',
    },
    initialTargetTerminalId: {
      type: String,
    }
  },
  data() {
    return {
      tradeContract: {
        ...defaultTradeContract,
        targetTerminalId: this.initialTargetTerminalId
      },
      contractType: this.initialContractType,
      customerTerminals: []
    }
  },
  created() {
    this.form && this.form.register(this);
  },
  beforeDestroy() {
    this.form && this.form.unregister(this)
  },
  computed: {
    ...mapGetters({
      account: 'hcs/account',
      hcsClient: 'hcs/client',
    }),
    isOffer() {
      return this.contractType === 'offer';
    },
    isDraft() {
      return this.contractType === 'draft';
    },
    isRecruitment() {
      return this.contractType === 'recruitment';
    },
    hasError() {
      const tc = this.tradeContract;
      if(!tc.name) {
        return true;
      }
      if(this.isRecruitment || this.isOffer) {
        return false;
      }
      return !tc.targetTerminalId;
    },
  },
  methods: {
    async load() {
      const result = [];

      // 取引先事業者のサイト
      const {data: customerTerminals} = await this.hcsClient.get('/assets/customer_terminals');
      customerTerminals
          .filter(ct => ct.ownerId !== this.account?.owner?.id)
          .forEach(ct => result.push(ct));

      // 自事業者のサイト
      const {data: terminals} = await this.hcsClient.get('/terminals');
      terminals
          .filter(t => t.id !== this.account?.user?.terminalId)
          .forEach(t => result.push(t));

      // マージ
      this.customerTerminals = result
          .map(t => ({
            ...t,
            selected: false,
          }))
          .sort((a, b) => {
            const s = sortFn(a.owner.name, b.owner.name);
            if(s !== 0) {
              return s;
            }
            return sortFn(a.name, b.name);
          });
    },
    setSelected(row) {
      this.customerTerminals.forEach(ct => {
        ct.selected = ct.id === row.id && ct.owner.id === row.owner.id;
      });
      this.tradeContract.targetTerminalId = row.id;
    },
    emitInput() {
      this.$emit('input', {
        ...this.tradeContract,
        recipientTerminalId: this.tradeContract.targetTerminalId,
        sendType: 'push',
        contractType: this.contractType,
      });
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if(!value) {
          this.tradeContract = {
            ...defaultTradeContract,
            targetTerminalId: this.initialTargetTerminalId
          };
          this.customerTerminals.forEach(ct => {
            ct.selected = false;
          });
        }
      }
    },
    tradeContract: {
      deep: true,
      handler() {
        this.emitInput();
      }
    },
    contractType: {
      handler() {
        this.emitInput();
      }
    },
    'dialog.visible': {
      immediate: true,
      handler(visible) {
        if(visible && !this.isOffer) {
          const loading = this.$loading({
            lock: true,
            spinner: 'el-icon-loading',
          });
          this.load()
              .finally(() => {
                loading.close();
              });
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
